import React from 'react';

import { Stack } from '@mantine/core';
import { AthleteClassMeta } from 'hooks/athleteClass/useAthleteClassMeta';
import { KiloClassAthleteAgenda, KiloClassAthleteRetrieve } from 'types';

import AthleteClassReserveButton from './AthleteClassReserveButton';
import AthleteClassStateLabel from './AthleteClassStateLabel';
import AthleteClassSupplementalText from './AthleteClassSupplementalText';

interface AthleteClassStateStackProps {
  athleteClassMeta: AthleteClassMeta;
  kiloClass: KiloClassAthleteAgenda | KiloClassAthleteRetrieve;
  size?: 'md' | 'lg' | 'xl';
}

const AthleteClassStateStack = ({
  athleteClassMeta,
  kiloClass,
  size,
}: AthleteClassStateStackProps): JSX.Element => {
  const supplementalSize = size === 'md' ? 'sm' : size === 'lg' ? 'md' : 'lg';
  return (
    <Stack spacing={4} align='center'>
      {athleteClassMeta.reserveAction && (
        <AthleteClassReserveButton
          killoClass={kiloClass}
          action={athleteClassMeta.reserveAction}
          fullWidth
          size={supplementalSize}
        />
      )}
      {athleteClassMeta.stateText && (
        <AthleteClassStateLabel athleteClassMeta={athleteClassMeta} size={size} />
      )}
      {athleteClassMeta.supplementalText && (
        <AthleteClassSupplementalText athleteClassMeta={athleteClassMeta} size={supplementalSize} />
      )}
    </Stack>
  );
};

export default AthleteClassStateStack;
